import { z } from "zod";
import { bulkIdsSchema, reviewStateSchema } from "../http";
import { webhookRecordSchema } from "../integrations/webhook";
export const deliveryListItemSchema = z.object({
  id: z.string(),
  destination_name: z.string(),
  provider: z.string(),
  record_key: z.string(),
  state: z.string(),
  trigger: z.string(),
  status: z.string(),
  attempts: z.number(),
  http_status: z.number().nullable(),
  error: z.string().nullable(),
  created_at: z.string(),
  next_attempt_at: z.string().nullable(),
  workflow_id: z.string().nullable(),
  title: z.string(),
});
export const deliveryListSchema = z.object({
  rows: z.array(deliveryListItemSchema),
  hasNext: z.boolean(),
  total: z.number(),
  destinations: z.array(z.string()),
});
export const deliveryDetailSchema = z.object({
  id: z.string(),
  status: z.string(),
  error: z.string().nullable(),
  destination: z.string(),
  payload: z.object({
    schemaVersion: z.literal(1),
    id: z.string(),
    event: z.literal("record.sent"),
    createdAt: z.string(),
    review: z.object({
      state: reviewStateSchema,
      previousState: z.string().nullable(),
    }),
    record: webhookRecordSchema,
    outboundBody: z.record(z.string(), z.unknown()).optional(),
  }),
  attempts: z.array(
    z.object({
      id: z.string(),
      attempt: z.number(),
      status: z.string(),
      http_status: z.number().nullable(),
      error: z.string().nullable(),
      duration_ms: z.number().nullable(),
      started_at: z.string(),
      finished_at: z.string().nullable(),
    }),
  ),
});
export const deliveryActionInput = z.object({
  action: z.enum(["retry", "retry_current", "cancel"]),
});
export const deliveryBulkActionInput = deliveryActionInput.extend({
  ids: bulkIdsSchema,
});
